export default {
  path: '/tutorial',
  name: 'Tutorial',
  redirect: '/tutorial/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/tutorial'),
      meta: { requiresAuth: true }
    },
    {
      path: 'detail',
      component: () => import('@/views/tutorial/Detail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'create',
      component: () => import('@/views/tutorial/CreateTutorial'),
      meta: { requiresAuth: true }
    },
    {
      path: 'quick',
      component: () => import('@/views/tutorial/QuickTutorial'),
      meta: { requiresAuth: true }
    },
    {
      path: 'edit',
      component: () => import('@/views/tutorial/EditTutorial'),
      meta: { requiresAuth: true }
    },
    {
      path: 'editMatch',
      component: () => import('@/views/tutorial/EditMatchTutorial'),
      meta: { requiresAuth: true }
    },
    {
      path: 'quickCreate',
      component: () => import('@/views/tutorial/QuickCreateTutorial'),
      meta: { requiresAuth: true }
    },
    {
      path: 'createMatch',
      component: () => import('@/views/tutorial/CreateMatchTutorial'),
      meta: { requiresAuth: true }
    },
    {
      path: 'moreMedia',
      component: () => import('@/views/media/more'),
      meta: { requiresAuth: true }
    },

    {
      path: 'centerTutorial',
      component: () => import('@/views/tutorial/centerTutorial'),
      meta: { requiresAuth: true }
    }
  ]
}
